// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"03f95248bae84f1c55805b5802fc7fc01367d134"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/ariza/assets/production-20250708092520-03f95248bae84f1c55805b5802fc7fc01367d134";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env.sentryDsn,
  enabled: process.env.NODE_ENV !== "test",
  release: process.env.sentryRelease,
  ignoreErrors: [],
});
